export default {"src":"/_next/static/media/thumbnail.d0cab49a.svg","height":581,"width":1199};